export interface PassageReportModel {
    matchId: string;
    matchName: string;
    seasonSeriesName: string;
    round: string;
    homeTeam: PassageTeam;
    awayTeam: PassageTeam;
    dateString: string;
    refereeName: string;
    passages: Passage[];
    passageTimes: PassageTime[];
    passageBreakdowns: PassageBreakdown[];
    teamRanges: TeamRanges[];
    timeOffsBreakdown: TimeOffsBreakdown;
    bopBreakdown: Range;
}

export interface PassageTeam {
    teamId: string;
    name: string;
    color: string;
    isPrimary: boolean;
    possessionBreakdown: Range;
}

export interface Range {
    totalCount: number;
    totalDuration: number;
    totalDurationString: string;
    rangeItems: RangeItem[];
}

export interface TeamRanges {
    eventCodeId: string;
    eventCodeName: string;
    homeCount: number;
    awayCount: number;
}

export interface RangeItem {
    eventCodeId: string;
    eventCodeName: string;
    count: number;
    duration: number;
    durationString: string;
}

export interface TimeOffsBreakdown {
    count: number;
    duration: number;
    durationString: string;
}

export interface Passage {
    passageType: string;
    index: number | null;
    duration: number | null;
    durationString: string;
    durationSeconds: number;
    passageItems: PassageItem[];
}

export interface PassageItem {
    teamId: string | null;
    teamName: string;
    color: string;
    rangeType: string;
    rangeTypeName: string;
    segmentNumber: number;
    segmentName: string;
    startEvent: PassageEvent;
    endEvent: PassageEvent;
    index: number | null;
    duration: number | null;
    durationString: string;
    durationSeconds: number;
    phaseCount: number;
    scoringEventName: string;
    endsInScoringEvent: boolean;
}

export interface PassageEvent {
    eventCodeId: string;
    eventCodeName: string;
    fieldLocation: string;
    time: number;
    timeString: string;
}

export interface PassageTime {
    rangeType: string;
    description: string;
    duration: number;
    durationString: string;
}

export interface PassageBreakdown {
    type: PassageBreakdownType;
    description: string;
    value: number;
    count: number;
    valueString: string;
}

export enum PassageBreakdownType {
    Total = 0,
    Average = 1,
    LessThan30s = 2,
    GreaterThan30s = 3,
    GreaterThan45s = 4,
    GreaterThan60 = 5,
    GreaterThan90s = 6,
    GreaterThan120s = 7,
    GreaterThan180s = 8
}

export enum RangeTypes {
    MatchTime = "ad693286-fff3-472e-a169-8a2e794d99ce",
    BIPTime = "53cff875-845e-4f27-a6d0-5f128bea5207",
    BOPTime = "fe004227-d079-42df-8e94-b8fab2887b77",
    ABIPTime = "845ac36e-5e33-4405-8a55-d1f81ab4337c"
}